import {
  CommonEntitiesListResponse,
  SupportedCountryResponse,
} from '@docbay/schemas';
import axiosAuthInstance from './axiosAuthInstance';

/**
 * API methods for interacting with countries data.
 */
export const CountriesAPI = {
  /**
   * Retrieves a list of supported countries.
   *
   * @returns A promise that resolves to the response containing
   *          a list of supported countries.
   */
  getSupportedCountries: async () => {
    return await axiosAuthInstance('').get<
      CommonEntitiesListResponse<SupportedCountryResponse>
    >('/countries/supported');
  },
};
